import { IconPlaceDown, IconPickUp } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import SensorHandle from '../SensorHandle';
import BaseNode from '../BaseNode';
import { SensorTrihowSpecificNodeType } from '../types';

export const SensorNFCNodeSpecific = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: SensorTrihowSpecificNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    const { trihow, channel, language } = data.options;
    return (
      <BaseNode
        selected={selected ?? false}
        type="sensor"
        isValid={data.isValid}
        disabled={disabled ?? false}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Specific Trihow',
              id: '+X6I9p',
            })}
          </T>
          <T body2>
            {trihow && trihow.length > 0
              ? `${trihow.length === 1 ? trihow[0].name : 'Trihows'} | ${channel ?? intl.formatMessage({ defaultMessage: 'Any', id: 'ToO3/h' })} | ${language ?? intl.formatMessage({ defaultMessage: 'Any', id: 'ToO3/h' })}`
              : intl.formatMessage({
                  defaultMessage: 'Trihow',
                  id: 'YUy+h3',
                })}
          </T>
        </Flex>
        <div style={{ width: '1px', background: 'white' }} />
        <Flex direction="column" grow gap={4} justify="center">
          <Flex align="center" gap={4}>
            <IconPlaceDown />
            <T body2>
              {intl.formatMessage({
                defaultMessage: 'Place',
                id: 'VfktxJ',
              })}
            </T>
          </Flex>
          <Flex align="center" gap={4}>
            <IconPickUp />
            <T body2>
              {intl.formatMessage({
                defaultMessage: 'Take',
                id: '7VAJTh',
              })}
            </T>
          </Flex>
        </Flex>
        <SensorHandle id="active" posTop="30%" disabled={disabled} />
        <SensorHandle id="passive" posTop="70%" disabled={disabled} />
      </BaseNode>
    );
  },
);
